/* eslint-disable no-sequences */
import React from "react";

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ReorderDiagnosticoModel } from './reorderDiagnostico.model';
import Return from "../../../images/return.png";
import { FaRegBell } from "react-icons/fa";
import { BaSeButton } from "@base/react";
import './style.scss';


export const ReoderDiagnostico = (props) => {

  const { tipos, onClose } = props;

  const {
    tipo,
    setTipo,
    dataType,
    updateOrder,
    saveOrder,
    isLoading,
  } = ReorderDiagnosticoModel(props);

  const backList = () => {
    onClose()
  }

  return (
    <div>
      <div className="container-principal" >
        <div className="filtro-container" style={{ backgroundColor: '#cc66cc' }}>
          <div className="modal-flex-direction-row">
            <FaRegBell size={40} color='#ffffff' />
            <h2 className="text-color-branco-titulo">Diagnósticos</h2>
            <div className="div-acoes-carrossel">
              <div className="icons-acoes-modal-filtro">
                <img onClick={backList} alt="imagem" className="writin" src={Return} />
                <p className="text-color-branco">Voltar</p>
              </div>
            </div>
          </div>
        </div>
        <hr size="1" className="separador-servicos"></hr>

        <div className='filters-content'>
          <div className='filter-container' style={{ borderBottom: '1px solid #cc66cc' }}>
            <h3 style={{ color: '#cc66cc' }}>Organizar</h3>
          </div>
          <div className="div-acoes-funcionalidade">
            <div className='container-itens'>
              <p className="text-campos-cadastro">Tipo de diagnóstico<span className='mandatory-diagnostico'>*</span></p>
              <div className='button-container'>
                <select
                  onChange={e => setTipo(e.target.value)}
                  className='btn-select-funcionalidades height-36' value={tipo}>
                  {tipos.map(tp => (
                    <option value={tp} title={tp}>{tp}</option>
                  ))}
                </select>
                <BaSeButton
                  width={100}
                  value="Salvar"
                  color='#cc66cc'
                  onClick={saveOrder}
                />
              </div>
            </div>
          </div>

          <div className='background-grey m-t-30 padding-container'>

            <div className="container-draggable" style={{ borderBottom: '1px solid #cc66cc' }} >
              <text className='id-container bold'>Ordem</text>
              <text className='titulo-container bold'>Título</text>
              <text className='descricao-container bold'>Descrição</text>
            </div>

            {isLoading
              ? (
                <div className="container-draggable" style={{ borderBottom: '1px solid #cc66cc' }} >
                  <text >Carregando</text>
                </div>
              ) : (
                <DragDropContext onDragEnd={updateOrder}>
                  <Droppable droppableId="characters">
                    {(provided) => (
                      <div className='characters background-grey' {...provided.droppableProps} ref={provided.innerRef} style={{ display: 'flex', flexDirection: 'column' }}>
                        {dataType.map(({ titulo, id, descricao }, index) => (
                          <Draggable key={`${id}`} draggableId={`${id}`} index={index} >
                            {(providedDragabble) => (
                              <div
                                className='container-draggable'
                                ref={providedDragabble.innerRef}
                                {...providedDragabble.draggableProps}
                                {...providedDragabble.dragHandleProps}
                              >
                                <text className='id-container bold'>{index + 1}</text>
                                <text className='titulo-container color-grey'>{titulo}</text>
                                <text className='descricao-container color-grey'>{descricao}</text>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}